import React from "react";
import { Accordion, AccordionSummary } from "@material-ui/core";
import clsx from "clsx";
import Hidden from '@material-ui/core/Hidden'
import Typography from "@material-ui/core/Typography";
import { useRowFlexStyles } from "@mui-treasury/styles/flex/row";
import { useHistory } from "react-router-dom";
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';

import CompletedSurveyModal from "./modals/CompletedSurveyModal";
import { SnapShotSurveyData } from "../../utils/services/cache/ClientCache";
import useStyles from "../../styles/components/survey/stylesSurveyHolderDetail";
import { Coin } from "../shared/component";

const SurveyListHolder = ({ surveyWithHistory }) => {
    const classes = useStyles();
    const history = useHistory();
    const flexStyles = useRowFlexStyles();
    const [open, setOpen] = React.useState(false);
    const [hover, setHover] = React.useState(false);
    let surveyName = surveyWithHistory.snapshot.title;
    let gradeText = "";
    let gradeChip;
    let recommendation = "";
    let coinText = surveyWithHistory.snapshot.coins;
    let isClosed = surveyWithHistory.isClosed
    let checked = false;
    if (surveyWithHistory.completed) {
        checked = true;
        if (surveyWithHistory.snapshot.traitId !== null) {
            recommendation =
                surveyWithHistory.history.sectionTraitCategoryModel?.description ===
                    null
                    ? ""
                    : surveyWithHistory.history.sectionTraitCategoryModel?.description;
            gradeText =
                "Evaluation : " +
                surveyWithHistory.history.sectionTraitCategoryModel?.categoryName;

            gradeChip = (
                <Typography
                    className="surveylistholder__evaluation"
                    onClick={() => handleSurvey(surveyWithHistory)}
                >
                    {gradeText}
                </Typography>
            );
        }
    } else {
        gradeChip = "";
    }

    const handleSurvey = (swh) => {
        if (isClosed && !surveyWithHistory.completed) {
            return
        }

        if (swh.snapshot.traitId !== null) {
            if (!swh.completed) {
                SnapShotSurveyData.setSnapshotSurveyId(swh.snapshot.id);
                SnapShotSurveyData.setSnapshotSurveyName(surveyName);
                SnapShotSurveyData.setSnapshotRewardPoint(
                    surveyWithHistory.snapshot.coins
                );
                return history.push("/SurveyQuestionList");
            } else setOpen(true);
        } else {
            if (!swh.completed) {
                SnapShotSurveyData.setSnapshotSurveyId(swh.snapshot.id);
                SnapShotSurveyData.setSnapshotSurveyName(surveyName);
                SnapShotSurveyData.setSnapshotRewardPoint(
                    surveyWithHistory.snapshot.coins
                );
                return history.push("/SurveyQuestionList");
            }
        }
    };

    const handleClose = () => setOpen(false);

    const showStatusSectionSurvey = () => {
        if (isClosed && !surveyWithHistory.completed) {
            return 'Expired'
        } else {
            if (hover) {
                return 'Click to begin'
            } else {
                if (checked) {
                    return 'Completed'
                } else {
                    return 'Yet to begin'
                }
            }
        }
    }

    return (
        <Accordion expanded={true} classes={{ root: classes.rootAccordion }}
            className={clsx(isClosed && !surveyWithHistory.completed && classes.rootAccordionStatusExprired)}
            onMouseEnter={() => { if (!checked) { setHover(true) } }}
            onMouseLeave={() => { if (!checked) { setHover(false) } }}>
            <AccordionSummary
                onClick={() => handleSurvey(surveyWithHistory)}
                classes={{ root: classes.rootAccordionSummary }}
                aria-label="Expand"
                className={flexStyles.parent}
                aria-controls="additional-actions1-content"
                id="additional-actions1-header"
            >
                <div style={{ flexBasis: "33.33%", flexShrink: 0, textAlign: "left" }}>
                    <Typography variant="body1" classes={{ body1: classes.rootTypographyHover }}>
                        {surveyWithHistory.snapshot.title}
                    </Typography>
                </div>
                <div style={{ flexBasis: "33.33%", textAlign: 'center' }}>
                    <Typography
                        variant="body1"
                        className={clsx(
                            classes.rootTypographyHover,
                            isClosed && !surveyWithHistory.completed ? classes.rootTableCellStatusExprired :
                                checked ? classes.rootTableCellStatus : classes.rootTypography,
                        )}
                    >
                        {showStatusSectionSurvey()}
                    </Typography>
                    {
                        surveyWithHistory.snapshot.traitId !== null ?
                            <Chip style={{ backgroundColor: '#4DD091', color: "white" }} avatar={<Avatar style={{ backgroundColor: "white" }}>T</Avatar>} label="Trait" /> : <></>
                    }
                </div>
                <div className={flexStyles.rightChild} style={{ marginTop: 3 }}>
                    <Hidden smDown>
                        <Coin coin={coinText} size="medium" />
                    </Hidden>
                    <Hidden mdUp>
                        <Coin coin={coinText} size="small" />
                    </Hidden>
                </div>
            </AccordionSummary>
            <CompletedSurveyModal
                isOpen={open}
                extraContent={null}
                closeAction={handleClose}
                surveyName={surveyName}
                gradeText={gradeText}
                recommendation={recommendation}
            />
        </Accordion>
    );
};

export default SurveyListHolder;